import attributeKeys from "../../hooks/api/attributes/attributeKeys";
import sortByProperty from "../Utilities/sortByProperty";

const editAttributesStore = ({ queryClient, editedItems }) => {
  queryClient.setQueryData(attributeKeys.attributes, (current) => {
    const oldAttributes = [...current];
    if (editedItems?.length > 0) {
      editedItems.forEach((item) => {
        const indexToUpdate = oldAttributes.findIndex(
          (old) => old.id === item.id
        );
        oldAttributes[indexToUpdate] = { ...item };
      });
    }
    const sortedArray =
      oldAttributes?.length > 0 ? sortByProperty(oldAttributes, "detail") : [];
    return sortedArray;
  });
};

export default editAttributesStore;
